/**
 * Contains the constants related to task creationContext externalSource
 */ (function(ContextScenarioConstants) {
    ContextScenarioConstants.meetingNotes = "com.microsoft.fluid.meetingNotes";
    ContextScenarioConstants.loop = "com.microsoft.fluid.loop";
    ContextScenarioConstants.teamsMessage = "com.microsoft.teams.message";
    ContextScenarioConstants.project = "com.microsoft.project.plannerIntegration";
    ContextScenarioConstants.businessExtensibility = "com.microsoft.businessExtensibility";
    ContextScenarioConstants.meetingPlan = "com.microsoft.teams.meeting";
    ContextScenarioConstants.meetingPlanScheduled = "com.microsoft.teams.meeting.scheduled";
    ContextScenarioConstants.teamsChannelAgentContext = "com.microsoft.teams.channel";
})(ContextScenarioConstants || (ContextScenarioConstants = {}));
export var ContextScenarioConstants;
